export const systemMessages = {
	error: "Estamos sem energia 🪫. Por favor tente novamente em alguns minutos!",
};
